export default __webpack_public_path__ + "assets/img/fontawesome-webfont.6878d55e3615ccf40c386ec2a90dfd6a.svg";